import React from "react";
import Controls from "./Controls";
import {Autocomplete} from "@material-ui/lab";

export default function AutoCompleteSelect(props) {
    let {options,
        inputValue,
        setInputValue,
        noOptionsText,
        inputTextChange,
        inputLabelText,
        error,
        autoCompleteInputChange,
        ...others} = props;

    return (
        <Autocomplete
            // ListboxProps={{
            //     onScroll: (event: React.SyntheticEvent) => {
            //         const listboxNode = event.currentTarget;
            //         console.log(listboxNode)
            //         if (listboxNode.scrollTop + listboxNode.clientHeight === listboxNode.scrollHeight) {
            //             console.log('here')
            //         }
            //     }
            // }}

            filterOptions={x => {
                return x;
            }}
            options={options}
            autoComplete
            includeInputInList
            inputValue={inputValue}
            onInputChange={autoCompleteInputChange}
            noOptionsText={noOptionsText}
            renderInput={params => (
                <Controls.Input
                    {...params}
                    label={inputLabelText}
                    fullWidth
                    onChange={inputTextChange}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                    error={error}
                />
            )}
            {...others}
        />
    )
}
